// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 6723) return "static/chunks/worker-chunks-29e64f8cdf5cd899.js";
	if (chunkId === 8940) return "static/chunks/8940-6131cf721eb30d78.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1843":"1e550dcb82fe65ae","6776":"0440f85945ba4278"}[chunkId] + ".js";
};